var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Block, SylController, SylPlugin } from '@syllepsis/adapter';
var NAME = 'header';
var Header = /** @class */ (function (_super) {
    __extends(Header, _super);
    function Header() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = NAME;
        _this.tagName = function (node) { return "h" + ((node && node.attrs.level) || 1); };
        _this.textMatcher = [
            {
                matcher: /^(#{1,6})\s$/,
                handler: function (match) {
                    return {
                        level: match[1].length
                    };
                }
            }
        ];
        _this.attrs = {
            level: {
                default: 1
            }
        };
        _this.parseDOM = [
            { tag: 'h1', attrs: { level: 1 } },
            { tag: 'h2', attrs: { level: 2 } },
            { tag: 'h3', attrs: { level: 3 } },
            { tag: 'h4', attrs: { level: 4 } },
            { tag: 'h5', attrs: { level: 5 } },
            { tag: 'h6', attrs: { level: 6 } }
        ];
        return _this;
    }
    return Header;
}(Block));
var HeaderController = /** @class */ (function (_super) {
    __extends(HeaderController, _super);
    function HeaderController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = NAME;
        _this.toolbar = {
            className: 'header',
            tooltip: 'header',
            type: 'select',
            value: [
                {
                    attrs: false
                },
                {
                    attrs: { level: 1 }
                },
                {
                    attrs: { level: 2 }
                },
                {
                    attrs: { level: 3 }
                }
            ]
        };
        return _this;
    }
    return HeaderController;
}(SylController));
var HeaderPlugin = /** @class */ (function (_super) {
    __extends(HeaderPlugin, _super);
    function HeaderPlugin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = NAME;
        _this.Controller = HeaderController;
        _this.Schema = Header;
        return _this;
    }
    return HeaderPlugin;
}(SylPlugin));
export { Header, HeaderController, HeaderPlugin };
//# sourceMappingURL=index.js.map